import { Routes } from '@angular/router';

// guards
// tests whether opp returned 404, also (incidentally but crucially) sets local OpportunityDetails object
import { OpportunityViewGuardService } from './guards/opportunity-view-guard.service';
// whether a user has edit permission
import { OpportunityManageGuardService } from './guards/opportunity-manage-guard.service';
// whether an opp has an external provider
import { OpportunityInterestedGuardService } from './guards/opportunity-interested-guard.service';

// resolves
import { OpportunityDetailsResolver } from './resolves/opportunity-details.resolver';

// components
import { OpportunityNotFoundComponent } from '../components/opportunity-view/opportunity-not-found/opportunity-not-found.component';
import { OpportunityViewComponent } from '../components/opportunity-view/opportunity-view.component';
import { OpportunityViewDiscoverComponent } from '../components/opportunity-view/opportunity-view-discover/opportunity-view-discover.component';
import { OpportunityViewInsightsComponent } from '../components/opportunity-view/opportunity-view-insights/opportunity-view-insights.component';
import { OpportunityViewInterestedComponent } from '../components/opportunity-view/opportunity-view-interested/opportunity-view-interested.component';
import { OpportunityViewOverviewComponent } from '../components/opportunity-view/opportunity-view-overview/opportunity-view-overview.component';

export const OPPORTUNITY_ROUTES: Routes = [
  // overview tab
  {
    path: '',
    component: OpportunityViewOverviewComponent,
  },
  // discover tab
  {
    path: 'discover',
    component: OpportunityViewDiscoverComponent,
    canActivate: [OpportunityManageGuardService],
  },
  // insights tab
  {
    path: 'insights',
    component: OpportunityViewInsightsComponent,
    canActivate: [OpportunityManageGuardService],
  },
  // interested tab
  {
    path: 'interested',
    component: OpportunityViewInterestedComponent,
    canActivate: [
      OpportunityManageGuardService,
      OpportunityInterestedGuardService,
    ],
  },
  // catch anything else and redirect to overview tab
  {
    path: '**',
    redirectTo: '',
  },
];

export const OPPORTUNITIES_ROUTES: Routes = [
  {
    path: ':id',
    component: OpportunityViewComponent,
    canActivate: [OpportunityViewGuardService],
    resolve: {
      details: OpportunityDetailsResolver,
    },
    children: OPPORTUNITY_ROUTES,
  },
  // catch anything else and redirect to Not Found
  // TODO: This will need more thought when we also match
  // to other opportunities segments, e.g. career/opportunities
  {
    path: '**',
    component: OpportunityNotFoundComponent,
  },
];
